import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "@mantine/core";
import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ImagePrefixEnum } from "../graphql/graphql.js";
import { getRandomColor } from "../utils/Color.utils.js";
import { createAcronym } from "../utils/String.utils.js";
export const ImageWithPlaceholder = ({ prefix = ImagePrefixEnum.Avatars, imageUrl, imageKey, imageVersion, avatarText, fallbackIcon, size = 50 }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const [color] = useState(getRandomColor());
    const lowerCasePrefix = prefix.toLowerCase();
    const handleImageLoad = () => {
        setImageLoaded(true);
    };
    const handleImageError = () => {
        setLoadError(true);
    };
    const renderPlaceholder = () => {
        return avatarText ? (_jsx(Avatar, { variant: "filled", size: size, color: color, children: createAcronym(avatarText, 2) })) : fallbackIcon ? (fallbackIcon) : (_jsx(Avatar, { src: "", alt: "", radius: "xl", size: size }));
    };
    // Create the versioned image URL if a version is provided.
    const versionedImageUrl = imageKey && imageVersion
        ? `${lowerCasePrefix}/${imageKey}?versionId=${imageVersion}`
        : imageKey
            ? `${lowerCasePrefix}/${imageKey}`
            : null;
    const src = imageUrl ??
        (versionedImageUrl
            ? `${import.meta.env.VITE_GET_IMAGE_URL}/${versionedImageUrl}`
            : undefined);
    return (_jsxs("div", { style: {
            width: size,
            height: size,
            borderRadius: "50%",
            overflow: "hidden",
            position: "relative"
        }, children: [(!imageLoaded || loadError) && (_jsx("div", { style: {
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }, children: renderPlaceholder() })), _jsx(LazyLoadImage, { wrapperClassName: "imageWithPlaceholderWrapper", className: "imageWithPlaceholder", style: { opacity: imageLoaded && !loadError ? 1 : 0 }, src: src, alt: "Avatar", onLoad: handleImageLoad, onError: handleImageError, width: "100%", height: "100%", threshold: 100, visibleByDefault: imageKey ? false : true })] }));
};
